import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Case_Arrow } from "../../../app-constants";
import { Link } from "gatsby";
import Logo1 from "../../images/location_new/caseimg/custom-logo-2.webp";
import Img1 from "../../images/location_new/caseimg/ios-dubai/Equitrip.webp";
import Logo2 from "../../images/location_new/caseimg/ios-dubai/yeppy-logo.png";
import Img2 from "../../images/location_new/caseimg/ios-dubai/Yeppy.webp";
import Logo3 from "../../images/location_new/caseimg/ios-dubai/save-logo.webp";
import Img3 from "../../images/location_new/caseimg/ios-dubai/Save-Win.webp";
import Logo13 from "../../images/location_new/caseimg/and-logo-4.webp";
import Img13 from "../../images/location_new/caseimg/ios-dubai/Selah.webp";

const CaseStudy = [
  {
    logo: Logo1,
    title: "The Idea Behind Equitrip",
    description:
      "Equitrip serves as a digital hub where horse owners, transport companies, and industry stakeholders unite to enhance horse transportation's convenience through collaboration.",
    link: "hde",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img1,
    BgColor: "#fff7d6",
    TextColor: "#18274d",
  },
  {
    logo: Logo2,
    title: "The Idea Behind Yeppy",
    description:
      "Yeppy Super App revolutionizes daily life, offering Financial, Booking, Retail, and Exclusive services in one seamless platform",
    link: "yeppy",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img2,
    BgColor: "#f8f8f8",
    TextColor: "#dc066a",
  },
  {
    logo: Logo3,
    title: "The Idea Behind Save & Win",
    description:
      "Save & Win is a mobile application that encourages users to save money and get rewarded for it. Basically, this type of money-saving application allows users to compare the prices of their favorite products.",
    link: "save-win",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img3,
    BgColor: "#bffeab",
    TextColor: "#000",
  },
  {
    logo: Logo13,
    title: "The Idea Behind Selah",
    description:
      "Selah is a social app designed to connect and interact with friends and family. It's a dedicated platform to socialize, chat, and share media with your loved ones.",
    link: "saleh",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: Img13,
    BgColor: "#f3f3f3",
    TextColor: "#000",
  },
];

function Stories(props) {
  return (
    <div className="section_stories p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="Success">
              <h2>Success Stories</h2>
            </div>
            <p>
              Explore the remarkable results we've achieved for our clients in
              iOS mobile app development.
            </p>
          </Col>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto"
              key={index}
            >
              <div
                className="stories_item"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="item_logo">
                  <LazyLoadImage
                    src={item.logo}
                    effect="blur"
                    alt={item.title}
                    className="img-fluid"
                  />
                  <ul
                    style={{
                      color: item.TextColor,
                      borderColor: item.TextColor,
                    }}
                  >
                    <li>{item.technology.iOS}</li>
                    <li>{item.technology.Android}</li>
                  </ul>
                </div>
                <div className="item_tech">
                  <div className="tech_content">
                    <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                    <p>{item.description}</p>

                    <Link
                      to={
                        item.link ? `/case-studies/${item.link}` : "/projects"
                      }
                      className="case_btn"
                      aria-label="TekRevol Contact"
                      style={{ backgroundColor: item.TextColor }}
                    >
                      View Case Study {Case_Arrow}
                    </Link>
                  </div>
                  <div className="tech_img">
                    <LazyLoadImage
                      src={item.Img}
                      effect="blur"
                      alt={item.title}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Stories;
